module.exports = __webpack_public_path__ + "static/mobEnterprise-ec34ddeb81e1c1f8e7aa22d23b9533b6.png";